const isFinanceUser = (user: any) => {
  if (user?.roles?.includes('user') && user?.group?.name === 'FinanceUser') {
    return true;
  }

  return false;
};

export default isFinanceUser;
